import { formatDateForBackend } from "../../helpers/date.helper";

export interface BaseDTO {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  includes?: string[];
}


export class Base {
  id: number;
  createdAt: Date;
  updatetAt: Date;
  deletedAt: Date;
  loadedRelations?: string[];

  constructor(source: any) {
    if (source) {
      this.id = source.id;
      this.createdAt = source.createdAt ? new Date(source.createdAt) : null;
      this.updatetAt = source.updatedAt ? new Date(source.updatedAt) : null;
      this.deletedAt = source.deletedAt ? new Date(source.deletedAt) : null;
    }
  }

  public static compare(b1: Base, b2: Base): boolean {
    return b1 && b2 ? b1.id === b2.id : b1 === b2;
  }

  protected isToBeExcluded(fieldName: string, excludes?: string[]) {
    return excludes && excludes.indexOf(fieldName) > -1;
  }

  public toDTO(): BaseDTO {
    return {
      id: this.id,
      includes: this.loadedRelations,
      createdAt: this.createdAt ? formatDateForBackend(this.createdAt, true) : null,
      updatedAt: this.updatetAt ? formatDateForBackend(this.updatetAt, true) : null,
      deletedAt: this.deletedAt ? formatDateForBackend(this.deletedAt, true) : null,
    };
  }

  get deleted(): boolean {
    return !!this.deletedAt;
  }

}


